import { Stack } from "@/Components/v2/atoms/Stack";
import { ActionPlanStatusMapping } from "../../action-plans/types";
import { ActionPlanStatus } from "@mutiny-group/sbo-openapi-client";
import { Typography as MuiTypography } from "@mui/material";

type StatusLabelProps = {
  status: ActionPlanStatus;
  onClick?: () => void;
};

const StatusLabel = ({ status, onClick }: StatusLabelProps) => {
  const { label, style } = ActionPlanStatusMapping[status];
  const Icon = style.icon;

  return (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      onClick={onClick}
      sx={{
        backgroundColor: style.backgroundColor,
        padding: "6px 12px",
        borderRadius: 1,
        border: `1px solid ${status === ActionPlanStatus.Complete ? "transparent" : style.color}`,
        cursor: onClick ? "pointer" : "default",
        "&:hover": onClick
          ? {
              opacity: 0.8,
            }
          : {},
      }}
    >
      {status === ActionPlanStatus.Complete && Icon && <Icon sx={{ color: style.color }} />}
      <MuiTypography
        fontSize={14}
        fontWeight={600}
        color={status === ActionPlanStatus.Complete ? "inherit" : "black"}
      >
        {label}
      </MuiTypography>
    </Stack>
  );
};

export default StatusLabel;
